import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  summary: string;
  coverImage: string;
  publishDate: string;
  category: string;
  tags: string[];
}

export default function ArticleCard({ id, title, slug, summary, coverImage, publishDate, category, tags }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${id}`} className="no-underline">
        <div className="aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={coverImage}
            alt={title}
            title={`${title} - 555电影`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">{category}</span>
          <span className="text-xs text-foreground-500">{publishDate}</span>
        </div>
        <Link to={`/article/${id}`} className="no-underline">
          <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {summary}
        </p>
        <div className="flex flex-wrap gap-1">
          {tags.map((tag) => (
            <span key={tag} className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}